module.exports = __webpack_public_path__ + "static/media/scroll02_0_3x.3c22412c.png";